import * as types from "../constants/actionTypes";

export const getPax = paxList => ({
  type: types.PAX_LOADED,
  payload: paxList
});

export const changeSelectedPaxIndex = id => ({
  type: types.SELECTED_PAX_INDEX_CHANGE,
  payload: id
});

export const resetSelectedPaxIndex = () => ({
  type: types.RESET_SELECTED_PAX_INDEX
});

export const resetPaxList = () => ({
  type: types.RESET_PAX_LIST
});

export const removePax = paxId => ({
  type: types.PAX_REMOVED,
  payload: { paxId }
});



// WEBPACK FOOTER //
// ./src/actions/paxActions.js